import React from "react";
import { Box, Typography, Chip, Stack } from "@mui/material";

const PageHeader = ({
  title,
  subtitle,
  icon: IconComponent,
  count,
  countLabel,
  actions,
  badgeGradient = "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
  badgeColor = "#ffffff",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        mb: 3.5,
        pb: 2.5,
        borderBottom: "1px solid #e2e8f0",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        {IconComponent && (
          <Box
            sx={{
              width: { xs: 42, sm: 48 },
              height: { xs: 42, sm: 48 },
              borderRadius: "14px",
              background: badgeGradient,
              color: badgeColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 6px 16px rgba(30, 41, 59, 0.12)",
              flexShrink: 0,
            }}
          >
            <IconComponent sx={{ fontSize: { xs: 22, sm: 26 } }} />
          </Box>
        )}
        <Box>
          <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">
            <Typography
              variant="h4"
              fontWeight={800}
              color="#0f172a"
              sx={{
                letterSpacing: "-0.02em",
                fontSize: { xs: "1.35rem", sm: "1.75rem" },
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>
            {count !== undefined && count !== null && (
              <Chip
                label={`${count} ${countLabel || ""}`.trim()}
                size="small"
                sx={{
                  backgroundColor: "#eff6ff",
                  color: "#2563eb",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                  borderRadius: "8px",
                  height: 24,
                  border: "1px solid #bfdbfe",
                }}
              />
            )}
          </Stack>
          {subtitle && (
            <Typography
              variant="body2"
              color="#64748b"
              fontWeight={500}
              sx={{ mt: 0.5, fontSize: { xs: "0.8125rem", sm: "0.875rem" } }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {actions && <Box sx={{ width: { xs: "100%", sm: "auto" } }}>{actions}</Box>}
    </Box>
  );
};

export default PageHeader;
